import React from "react";
import { useLocation } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";

interface Props {
  children: React.ReactNode;
}

/**
 * Wraps ErrorBoundary with route-change awareness.
 * When the user navigates to a different route, the error state is reset
 * so the new page renders normally instead of showing the stale error UI.
 */
const ErrorBoundaryWithReset: React.FC<Props> = ({ children }) => {
  const location = useLocation();

  return <ErrorBoundary resetKey={location.key}>{children}</ErrorBoundary>;
};

export default ErrorBoundaryWithReset;
